import React from 'react'
import classnames from 'classnames'
import { Icon } from '@scentregroup/ui'
import style from './index.module.scss'

interface IScrollButtonProps {
  onClick: () => void
  direction: 'up' | 'down' | 'left' | 'right'
}

const TABINDEX_NOT_TABBABLE = -1

const ScrollButton: React.FunctionComponent<
  React.PropsWithChildren<IScrollButtonProps>
> = ({ onClick, direction }) => {
  return (
    <button
      className={classnames(style.scrollButton, style[direction])}
      onClick={_e => onClick()}
      tabIndex={TABINDEX_NOT_TABBABLE}
      aria-hidden="true"
    >
      <Icon type={`chevron-${direction}`} size="small" className={style.icon} />
    </button>
  )
}

export default ScrollButton
